import React from 'react';

import NvrsTable from '../components/Nvr/NvrsTable.js';

const Nvrs = () => {
  return <NvrsTable />;
};

export default Nvrs;
